import { Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  selector: '[UIKitDropdown]',
})
export class DropdownDirective {
  // @ts-expect-error
  @Input() isDropdownOpened: boolean;
  // @ts-expect-error
  @Input() _open: boolean;

  @Output() openChange: EventEmitter<boolean> = new EventEmitter();

  isOpen(): boolean {
    return this._open;
  }

  open() {
    if (!this._open) {
      this._open = true;
      this.openChange.emit(true);
    }
  }

  close() {
    if (this._open) {
      this._open = false;
      this.openChange.emit(false);
    }
  }

  toggle() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  constructor() {}
}
